/**
 * SenderIdManagementService
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type SenderIdRequestStatus = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;

export const SenderIdRequestStatus = {
    NUMBER_0: 0 as SenderIdRequestStatus,
    NUMBER_1: 1 as SenderIdRequestStatus,
    NUMBER_2: 2 as SenderIdRequestStatus,
    NUMBER_3: 3 as SenderIdRequestStatus,
    NUMBER_4: 4 as SenderIdRequestStatus,
    NUMBER_5: 5 as SenderIdRequestStatus,
    NUMBER_6: 6 as SenderIdRequestStatus,
    NUMBER_7: 7 as SenderIdRequestStatus,
    NUMBER_8: 8 as SenderIdRequestStatus
};